
import { DollarSign } from "lucide-react";

interface OrderPaymentAmountProps {
  total: number;
  subtotal: number;
  tps: number;
  tvq: number;
}

export const OrderPaymentAmount = ({ total, subtotal, tps, tvq }: OrderPaymentAmountProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Montant à payer</h2>
      <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-gray-600">
            <span>Sous-total</span>
            <span>{subtotal.toFixed(2)} CAD</span>
          </div>
          <div className="flex justify-between text-sm text-gray-600">
            <span>TPS (5%)</span>
            <span>{tps.toFixed(2)} CAD</span>
          </div>
          <div className="flex justify-between text-sm text-gray-600">
            <span>TVQ (9.975%)</span>
            <span>{tvq.toFixed(2)} CAD</span>
          </div>
          <div className="pt-3 sm:pt-4 border-t">
            <div className="flex justify-between items-center">
              <div className="flex items-center space-x-1 sm:space-x-2">
                <DollarSign className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" />
                <span className="font-semibold text-gray-900">Total</span>
              </div>
              <span className="text-lg sm:text-xl font-bold text-gray-900">
                {total.toFixed(2)} CAD
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
